import BaseApi from './baseApi';
import IOutboundDocument from '../models/IOutboundDocument';
import IAuthentication from '../models/IAuthentication';
export default class OutboundDocumentApi extends BaseApi {
    idUser : string = "";
    constructor(page: string) {
        super("dataaccess", page);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetOutboundDocuments(idOutbound: string) : Promise<IOutboundDocument[]> {
        let json : string = this.getJsonRead(idOutbound);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var outboundDocuments: IOutboundDocument[] = [];
            outboundDocuments = response.data as IOutboundDocument[];
            return outboundDocuments;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveOutboundDocument(outboundDocument: IOutboundDocument) : Promise<string> {
        const json = this.getJsonSave(outboundDocument);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateOutboundDocument(outboundDocument: IOutboundDocument) : Promise<boolean> {
        const json = this.getJsonUpdate(outboundDocument);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDocument(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async DeleteOutboundDocumentByOutboundId(outboundId: string) : Promise<boolean> {
        const json = this.getJsonDeleteByOutboundId(outboundId);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDeleteByOutboundId(outboundId: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDocuments",
            "conditions": [{
                "Item1": "OutboundsDocuments",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": outboundId
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDocuments",
            "conditions": [{
                "Item1": "OutboundsDocuments",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(OutboundDocument: IOutboundDocument) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idListCustomPaper",
                "Item2": OutboundDocument.idListCustomPaper
            }, {
                "Item1": "description",
                "Item2": OutboundDocument.description
            }, {
                "Item1": "URL",
                "Item2": OutboundDocument.url
            }, {
                "Item1": "idCompany",
                "Item2": OutboundDocument.idCompany
            }, {
                "Item1": "idOutbound",
                "Item2": OutboundDocument.idOutbound
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDocuments"
        };
        return json;
    }

    private getJsonUpdate(OutboundDocument: IOutboundDocument) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idListCustomPaper",
                "Item2": OutboundDocument.idListCustomPaper
            }, {
                "Item1": "description",
                "Item2": OutboundDocument.description
            }, {
                "Item1": "URL",
                "Item2": OutboundDocument.url
            }, {
                "Item1": "idCompany",
                "Item2": OutboundDocument.idCompany
            }, {
                "Item1": "idOutbound",
                "Item2": OutboundDocument.idOutbound
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "OutboundsDocuments",
            "keyvalue": OutboundDocument.id
        };
        return json;
    }

    private getJsonRead(idOutbound: string) : any {
        const json = {
            "fields": [{
                "Item1": "OutboundsDocuments",
                "Item2": "id"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "idListCustomPaper"
            }, {
                "Item1": "ListCustomPapers",
                "Item2": "name as custompapername"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "description"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "url"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "idOutbound"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "idCompany"
            }],
            "tables": [{
                "Item1": "OutboundsDocuments"
            }, {
                "Item1": "ListCustomPapers"
            }],
            "joins": [{
                "Item1": "OutboundsDocuments",
                "Item2": "idListCustomPaper",
                "Item3": "ListCustomPapers",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "OutboundsDocuments",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "OutboundsDocuments",
                "Item2": "idOutbound",
                "Item3": "=",
                "Item4": idOutbound
            }]
        };
        return json;
    }
}
